import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { listAdminTickets, listQuoteRequests, getPublicSiteSettings, listOrders } from "@/lib/adminApi";
import { computeOverview, SLA_WARN_HOURS } from "@/lib/adminHelpers";
import useNoindex from "@/lib/useNoindex";

export function OverviewCards({ data }) {
  const items = [
    { id: "to-prepare", label: "Hazırlanacak raporlar", value: data.toPrepare || 0, to: "/admin/siparisler", warn: (data.toPrepare || 0) > 0 },
    { id: "open-tickets", label: "Açık destek talepleri", value: data.openTickets, to: "/admin/gelen-kutusu" },
    { id: "sla", label: `${SLA_WARN_HOURS} saatten eski, yanıtsız (24 sa SLA uyarısı)`, value: data.slaWarnings, to: "/admin/gelen-kutusu", warn: data.slaWarnings > 0 },
    { id: "new-quotes", label: "Yeni teklif başvuruları", value: data.newQuotes, to: "/admin/gelen-kutusu" },
    { id: "free-slots", label: "Kalan ücretsiz danışmanlık", value: data.freeSlotsLeft === null ? "-" : data.freeSlotsLeft, to: "/admin/hizmetler" },
  ];
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
      {items.map((it) => (
        <a key={it.id} href={it.to} data-testid={`overview-${it.id}`}>
          <Card className={it.warn ? "border-red-300 bg-red-50" : ""}>
            <CardHeader className="pb-2">
              <CardTitle className="text-sm font-medium text-muted-foreground">{it.label}</CardTitle>
            </CardHeader>
            <CardContent>
              <div className={`text-3xl font-bold ${it.warn ? "text-red-600" : ""}`}>{it.value}</div>
            </CardContent>
          </Card>
        </a>
      ))}
    </div>
  );
}

export default function Overview() {
  useNoindex();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let alive = true;
    Promise.all([listAdminTickets(), listQuoteRequests(), getPublicSiteSettings(), listOrders("paid").catch(() => [])])
      .then(([tickets, quotes, settings, orders]) => alive && setData(computeOverview({ tickets, quotes, settings, orders })))
      .catch(() => alive && setError("Veriler yüklenemedi."));
    return () => { alive = false; };
  }, []);
  return (
    <main className="mx-auto max-w-5xl px-4 py-6">
      <h1 className="mb-4 text-xl font-semibold">Genel bakış</h1>
      {error && <p className="text-sm text-red-600">{error}</p>}
      {!data && !error && <p className="text-sm text-muted-foreground">Yükleniyor...</p>}
      {data && <OverviewCards data={data} />}
    </main>
  );
}
